/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ApiStatus } from '../../../../ts/';
import { getRecognitionClusters } from '../actions';

export const recognitionReducers = {
  [getRecognitionClusters.pending.toString()]: state => {
    state.recognitionClusters.loading = ApiStatus.LOADING;
    state.recognitionClusters.error = null;
  },
  [getRecognitionClusters.fulfilled.toString()]: (state, action) => {
    const { recommendations, status, total_in_clusters } = action.payload;
    const formattedData = formatRecognitionClusters(recommendations);
    state.recognitionClusters.groups = formattedData;
    state.recognitionClusters.status = formatTrainingStatus(status);
    state.recognitionClusters.total = total_in_clusters;
    state.recognitionClusters.loading = ApiStatus.SUCCEEDED;
  },
  [getRecognitionClusters.rejected.toString()]: (state, action) => {
    state.recognitionClusters.loading = ApiStatus.ERROR;
    state.recognitionClusters.error = action.error;
  }
};

const formatRecognitionClusters = data => {
  const result = [];
  data?.forEach(item => {
    const { id, representative_examples, count, intent, frequency_percent } =
      item;
    result.push({
      id: id.toString(),
      examples: representative_examples,
      group: intent,
      count,
      frequency: frequency_percent
    });
  });
  return result;
};

const formatTrainingStatus = status => {
  let trainingStatus = null;

  if (status.includes('In Progress')) {
    trainingStatus = 'In Progress';
  } else if (status.includes('Updating')) {
    trainingStatus = 'Updating';
  } else {
    trainingStatus = status;
  }

  return trainingStatus;
};
